/* @ngInject */
const local = (
  storageHandler,
  valueHandler,
  wagonUtils
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentWagonId', wagonUtils.stringToId(_id))
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentWagonId', wagonUtils.stringToId(_id.id))
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentWagonId')
  }

  self.saveCurrentScrappedId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentWagonScrappedId', wagonUtils.stringToId(_id))
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentWagonScrappedId', wagonUtils.stringToId(_id.id))
    }
  }

  self.getCurrentScrappedId = () => {
    return storageHandler.get('currentWagonScrappedId')
  }

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/local.service.js